<template>
  <div class="restrictedList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-field
            readonly
            :value="searchForm.countryName"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showRestrictedListCountry')"
            class="custom-field"
            v-if="searchType == 1"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="searchForm.cityName"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showRestrictedListCity')"
            class="custom-field"
            v-else-if="searchType == 2"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.meta.searchText"
            v-else
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div @click="handleSheetShow">
            <span>{{ searchTypeStr }}</span>
          </div>
        </van-col>
      </van-row>
    </div>
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.marketRisk.customerNumber }}：{{ item.CustomerNumber }}
        </div>
        <div class="list-item">
          {{ $t.marketRisk.customerName }}：{{ item.CompanyName }}
        </div>
        <div class="list-item">{{ $t.marketRisk.country }}：{{ item.CountryName }}</div>
        <div class="list-item">{{ $t.marketRisk.city }}：{{ item.CityName }}</div>
        <div class="buttons">
          <van-button
            :class="item.IsRemove == '1' ? 'danger-btn' : 'default-btn'"
            size="small"
            type="primary"
            @click="editCustomerRestrictedIsRemove(item)"
          >
            <span v-if="item.IsRemove == '1'">{{ $t.marketRisk.setBlock }}</span>
            <span v-else>{{ $t.marketRisk.closeBlock }}</span></van-button
          >

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item)"
            >{{ $t.meta.view }}</van-button
          >
        </div>
      </div>
    </van-list>

    <option-list
      event="showRestrictedListCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showRestrictedListCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>

    <van-action-sheet
      :title="$t.meta.searchType"
      :closeable="false"
      v-model="sheetShow"
      :actions="sheetActions"
      @select="sheetSelect"
    />

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.marketRisk.newRestrict
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
} from "vant";
import OptionList from "@components/optionList/OptionList.vue";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker);

export default {
  name: "restrictedList",
  components: {
    OptionList,
  },
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      searchText: "",
      searchType: 1,
      searchTypeStr: this.$t.marketRisk.country,
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //搜索条件
      searchForm: {
        countryId: "",
        countryName: "",
        cityId: "",
        cityName: "",
      },
      //操作菜单
      sheetShow: false,
      sheetActions: [],
      //选项
      countryList: [],
      cityList: [],
    };
  },
  created() {
    this.getOptions();
  },
  methods: {
    gotoDetail(item) {
      var data = item;
      localStorage.setItem("restrictedDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "restrictedDetail",
        name: "restrictedDetail",
        query: [
          {
            name: "IsView",
            value: data ? true : false,
          },
        ],
      });
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    onSelectCountry(item) {
      this.searchForm.countryName = item.text;
      this.searchForm.countryId = item.value;
    },
    onSelectCity(item) {
      this.searchForm.cityName = item.text;
      this.searchForm.cityId = item.value;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    sheetSelect(e) {
      this.searchTypeStr = e.name;
      this.searchType = e.className;
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.marketRisk.country, className: "1" },
        { name: this.$t.marketRisk.city, className: "2" },
        { name: this.$t.marketRisk.lPerson, className: "3" },
        { name: this.$t.marketRisk.sales, className: "4" },
        { name: this.$t.marketRisk.phone, className: "5" },
        { name: this.$t.marketRisk.customerName, className: "6" },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CompanyId: this.CompanyId,
        CountryId: this.searchType == 1 ? this.searchForm.countryId : "",
        CityId: this.searchType == 2 ? this.searchForm.cityId : "",
        LegalPerson: this.searchType == 3 ? this.searchText : "",
        SalesName: this.searchType == 4 ? this.searchText : "",
        PhoneNumber: this.searchType == 5 ? this.searchText : "",
        CompanyName: this.searchType == 6 ? this.searchText : "",
      };
      this.$api.marketRisk
        .getCustomerRestrictedList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    editCustomerRestrictedIsRemove(item) {
      this.$commonMethod.showLoading();
      var param = {
        RestrictId: item.RestrictId,
        UserId: this.UserId,
      };
      this.$api.marketRisk
        .editCustomerRestrictedIsRemove(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getOptions() {
      return new Promise((resolve) => {
        Promise.all([this.getCountryList(), this.getCityList()]).then((success) => {
          if (success) resolve(true);
        });
      });
    },
    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCityList() {
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList({
            type: 1,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.City_cn + "," + item.City_en,
                value: item.Id,
              };
              result.push(data);
            });
            this.cityList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.restrictedList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .custom-field {
          padding: 10px 0px 10px 15px;
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
